import { GetErrorMessagesUnderElement, Clone } from "js-vextensions";
import { Column, Pre, Row, RowLR, TextInput } from "react-vcomponents";
import { BaseComponent, GetInnerComp } from "react-vextensions";
import { ShowMessageBox } from "react-vmessagebox";
import { AddBook } from "../../Server/Commands/AddBook";
import { Book } from "../../Store/firebase/books/@Book";
export class BookDetailsUI extends BaseComponent {
    ComponentWillMountOrReceiveProps(props, forMount) {
        if (forMount || props.baseData != this.props.baseData) { // if base-data changed
            this.SetState({ newData: Clone(props.baseData) });
        }
    }
    render() {
        const { forNew, enabled, style, onChange, creator } = this.props;
        const { newData } = this.state;
        const Change = _ => {
            if (onChange) {
                onChange(this.GetNewData());
            }
            this.Update();
        };
        const splitAt = 170, width = 600;
        return (React.createElement("div", null,
            " ",
            React.createElement(Column, { style: style },
                React.createElement(RowLR, { mt: 5, splitAt: splitAt, style: { width } },
                    React.createElement(Pre, null, "Name: "),
                    React.createElement(TextInput, { required: true, enabled: enabled, style: { width: "100%" }, value: newData.name, onChange: val => Change(newData.name = val) })))));
    }
    GetValidationError() {
        return GetErrorMessagesUnderElement(this)[0];
    }
    GetNewData() {
        const { newData } = this.state;
        return Clone(newData);
    }
}
export function ShowAddBookDialog(userID) {
    let newBook = new Book({ name: "" });
    let detailsUI;
    let error = null;
    const Change = (..._) => boxController.UpdateUI();
    let boxController = ShowMessageBox({
        title: `Add book`, cancelButton: true,
        message: () => {
            boxController.options.okButtonProps = { enabled: error == null /*, title: error*/ };
            return (React.createElement(Column, { style: { padding: `10px 0`, width: 600 } },
                React.createElement(BookDetailsUI, { ref: c => detailsUI = GetInnerComp(c), baseData: newBook, forNew: true, onChange: val => Change(newBook = val, error = detailsUI.GetValidationError()) }),
                error && error != "Please fill out this field." && React.createElement(Row, { mt: 5, style: { color: "rgba(200,70,70,1)" } }, error)));
        },
        onOK: () => {
            new AddBook({ book: newBook }).Run();
        },
    });
}
